//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {Swiper, SwiperSlide, directive} from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import "../api/jquery-1.11.1.min.js";

export default {
    name: "header",
    components: {
        Swiper,
        SwiperSlide,
    },
    directives: {
        swiper: directive,
    },
    data() {
        return {
            isMini: true,
            chotab: 1,
            swiperOptions: {
                pagination: {
                    el: ".swiper-pagination",
                },
                // Some Swiper option/callback...
            },
            banner: [],
            complete: "",
            name: "",
            phone: "",
            company: "",

            successMsg: "提交错误,尝试电话联系吧",
            showAlert: false
        };
    },
    methods: {
        callPhone(phoneNumber) {
            window.location.href = "tel://" + phoneNumber;
        },
        chotabs(index) {
            this.chotab = index;
        },
        getbanner() {
            this.axios
                .get("api/myy/banner/list", {
                    params: {
                        type: 0,
                    },
                })
                .then((res) => {
                    if (res.data.data) {
                        this.banner = res.data.data;
                        setTimeout(() => {
                            this.complete = true;
                        });
                    }
                });
        },
        jump(url) {
            window.location.href = url;
        },
        vailPhone(number) {
            let flag = false;
            let myreg = /^((13)|(14)|(15)|(16)|(17)|(18)|(19))\d{9}$/;
            if (!number || number.length !== 11) {
                flag = false;
            } else if (!myreg.test(number)) {
                flag = false;
            } else {
                flag = true;
            }
            return flag;
        },
        submes() {
            var host = "https://m.mingyuanyun.com/mingyuanyun";
            // var host = "https://m-test.mingyuanyun.com/test";

            var name = this.name;
            var phone = this.phone;
            var company = this.company;
            if (!name) {
                alert("姓名必填");
                return;
            }
            if (!this.vailPhone(phone)) {
                alert("请正确填写手机号");
                return;
            }
            if (!company) {
                alert("请填写所在的公司");
                return;
            }
            var content = {
                ActivityName: "移动官网反馈表单",
                ActivityGUID: "98551405-8f75-454a-ad3b-146b24e6191e",
                FeedbackGUID: null,
                Channel: "33",
                FormDetail: [
                    {FieldCode: "Name", FieldName: "姓名", FieldValue: name},
                    {FieldCode: "Phione", FieldName: "手机", FieldValue: phone},
                    {FieldCode: "CompanyName", FieldName: "公司", FieldValue: company},
                ],
                Creator: "",
                IsPhoneRepeater: 1,
                IsPhoneValid: 0
            };

            var param = {
                content: content,
                validCode: "",
            };
            this.$ajax.post(host + "/adminapi/myy/common/save-activity-form-v2", param)
                .then(res => {
                    if (res.result && (res.data || "").length === 36) {
                        // console.log("submit success", res.data);
                        alert("提交成功");
                        // this.showAlert = true;
                    } else {
                        alert("提交错误,尝试电话联系吧");
                        // this.showAlert = true;
                        // this.successMsg = "提交错误,尝试电话联系吧";
                    }
                });
        },
        hideAlert() {
            this.showAlert = false;
        },
        saveFormData(data, cb) {

            this.$ajax.post(`${api.save_activity_form_v2}`, data).then(res => {
                if (res['result'] && res['data']) {
                    if (cb) {
                        cb(true, res['data'])
                    }
                } else {
                    cb(false, res['msg'])
                }
            }).catch(err => {
                if (cb) {
                    cb(false, err)
                }
            })
        },
    },
    beforeCreate() {
        window.location.href = "https://www.mingyuanyun.com";
    },
    mounted() {
        try {
            var ua = navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                wx.miniProgram.getEnv((res) => {
                    this.isMini = res.miniprogram
                })
            } else {
                this.isMini = false;
            }
        } catch (ex) {
            this.isMini = false;
        }

        // this.mySwiper.slideTo(3, 1000, false)

        this.getbanner();
    },
};



// WEBPACK FOOTER //
// ./src/components/header.vue